"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reservation = require("@/api/reservation");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var cacheAddress = {};
var _default2 = exports.default = {
  name: 'DialogReschedule',
  props: {
    orderDetailList: {
      // 订单详情
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //商品列表
    productList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 订单号
    workOrderNoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isBatch: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return Date.now() - 8.64e7 > time.getTime();
        }
      },
      formInfoData: {},
      checkList: ['选中且禁用', '复选框 A'],
      form: {
        reservationDate: '',
        reservationTimeSlot: '',
        serviceType: 1,
        userName: '',
        userPhone: '',
        userAddress: '',
        workOrderNoList: [],
        isBatch: false
      },
      reservationTime: ["", ""],
      //时间段
      requiredList: [],
      // 必填项数据
      formProps: {},
      citysData: [],
      // 所有省市区数据
      rules: {
        reservationDate: [{
          required: true,
          message: '请选择日期',
          trigger: 'blur'
        }],
        userName: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        userPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        userAddress: [{
          required: true,
          message: '请输入上门地址',
          trigger: 'blur'
        }]
      },
      showPopover: false,
      dialogTableVisible: false,
      radio: null // 初始化 radio 变量
    };
  },
  watch: {
    orderDetailList: {
      handler: function handler(val) {
        this.setForm(val);
      },
      deep: true
    }
  },
  methods: {
    setForm: function setForm(val) {
      this.form.reservationDate = val.reservationDate;
      this.reservationTime = val.reservationTimeSlot ? val.reservationTimeSlot.split('-') : '';
      this.form.serviceType = val.serviceType;
      this.form.userName = val.userName;
      this.form.userPhone = val.userPhone;
      this.form.userAddress = val.userAddress;
    },
    openBox: function openBox() {
      // 获取整个省市区数据
      this.dialogTableVisible = true;
      if (this.orderDetailList) {
        this.setForm(this.orderDetailList);
      }
    },
    submitFn: function submitFn() {
      var _this = this;
      this.form.workOrderNoList = this.workOrderNoList;
      this.form.reservationTimeSlot = this.reservationTime.join('-');
      this.form.isBatch = this.isBatch;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          (0, _reservation.workOrderUpdateAgreementApi)(_this.form).then(function (res) {
            _this.$message.success('改约成功');
            _this.dialogTableVisible = false;
            _this.$emit('selectStaff');
          });
        } else {
          return false;
        }
      });
    }
  }
};